import React, { ReactElement } from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import EditPeriodisationDialog from "./editPeriodisationDialog";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";

function useEditPeriodisationDialog(invoice: WintSuperkollAPIModel.Invoice, reloadInvoice?: () => void, fileViewer?: ReactElement) {


  return (): DialogProps => ({
    isOpen: false,
    title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.EditPeriodisation),
    titleIcon: IconDefinitionConstants.WMonthCalendar,
    dialogType: DialogEnums.DialogType.Content,
    children: <EditPeriodisationDialog invoice={invoice} reloadInvoice={reloadInvoice} fileViewer={fileViewer} />,
    closeOnEscapeAnywhere: true,
    maxWidth: "md",
    fullWidth: true,
    className: clsx(cssExports.editPeriodisationDialog, fileViewer && cssExports.dialogFullHeight),
    actions: [
      {
        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Save),
        successMessage: TranslationKeys.Common.Saved,
      },
    ],
  });
}

export default useEditPeriodisationDialog;
